import OspreyApiHelper from './helper'

export default class OspreySummaryReports {

    static get(path, params) {
        return OspreyApiHelper.genericGet(path, params)
    }
}


// WEBPACK FOOTER //
// src/services/osprey-api/api-summary-reports.js